import { render, staticRenderFns } from "./CrmMessageEvent.vue?vue&type=template&id=2b8d4a1c"
import script from "./CrmMessageEvent.vue?vue&type=script&lang=ts"
export * from "./CrmMessageEvent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b8d4a1c')) {
      api.createRecord('2b8d4a1c', component.options)
    } else {
      api.reload('2b8d4a1c', component.options)
    }
    module.hot.accept("./CrmMessageEvent.vue?vue&type=template&id=2b8d4a1c", function () {
      api.rerender('2b8d4a1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crm/events/CrmMessageEvent.vue"
export default component.exports